<template>
    <!-- <b-container> -->
        <b-navbar toggleable="lg" variant="secondary">  
            <b-navbar-brand class="text-white">{{ titulo }}</b-navbar-brand>
            <slot name="content"></slot>        
        </b-navbar>    
    <!-- </b-container> -->
</template>

<script>
export default {
    data() {
        return {
        }
    },
    props: {
        titulo: String,
    },    
}
</script>